var _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { FormGridColumn } from './components';
import { StyledCacheWrapper } from '../../styles';
import StyledFormGrid from './form-grid.styles';
var propTypes = {
  /** FormGrid Content */
  children: PropTypes.node,
  /** Removes the FormGrid's horizontal margins when true. */
  collapsedH: PropTypes.bool,
  /** Removes the FormGrid's vertical margins when true. */
  collapsedV: PropTypes.bool
};
var defaultProps = {
  children: /*#__PURE__*/React.createElement(React.Fragment, null),
  collapsedH: false,
  collapsedV: false
};

/**
 * @ignore @description
 * ## FormGrid Component
 * A powerful mobile-first grid system for specifically developed for building forms. It’s based on a 12 column layout and has multiple tiers, one for each media breakpoint.
 *
 * @ignore @see Mesh: [FormGrid Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/scaffolding-formgrid--default)
 *
 * @ignore @example
 * ```jsx
 * import { FormGrid } from 'mesh-component-library';
 *
 * <FormGrid {...props}>
 *  {children}
 * </FormGrid>
 * ```
 */

var FormGrid = function FormGrid(_ref) {
  var children = _ref.children,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledFormGrid, other, children));
};
FormGrid.propTypes = propTypes;
FormGrid.defaultProps = defaultProps;
FormGrid.Column = FormGridColumn;
export default FormGrid;